import { OpenDialogTextComponent } from './../../../dialog/open-dialog-text/open-dialog-text.component';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { BookedOfferClub, BookingStatus } from 'app/shared/models/class/bookedOffer/bookedOffer';
import { BookedSessionByBookingKey, BookingUser } from 'app/shared/models/class/booking-session/booking-session';
import { FilterPopUpTable } from 'app/shared/models/class/filterPopupTable/filterPopUpTable';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { BookingSessionService } from 'app/shared/services/booking-session/booking-session.service';
import { BookingService } from 'app/shared/services/booking/booking.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { FilterpredicateService } from 'app/shared/services/filterPredicate/filterpredicate.service';
import { PdfService } from 'app/shared/services/pdf/pdf.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-table-offer-inprogress',
  templateUrl: './table-offer-inprogress.component.html',
  styleUrls: ['./table-offer-inprogress.component.scss']
})
export class TableOfferInprogressComponent extends SubscriptionBaseComponent implements OnInit {
  @Input() tab: string;
  @Input() set valueSearch(value: string) {
    if (this.dataSource !== undefined) { this.applyFilter(value); }
  }

  displayedColumns: string[] = ['offerNameOfferInProgress', 'bookedOfferRecordDate', 'bookedOfferStatus', 'bookingamount', 'leftToPay', 'overview', 'pdf'];
  dataSource = new MatTableDataSource<BookingUser>();
  expandedElement: any | null;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  bookingConvert: BookedOfferClub[];
  valueFilter: FilterPopUpTable[];
  clubCode: any;
  userConnected: any;
  bookOverview: BookingUser;
  // bookingStatus: BookingStatus[];
  bookedOfferStatusKey: number;
  bookingByClub: BookingUser[];
  sesisonBookSelected: BookedSessionByBookingKey[];

  constructor(
    private authService: AuthService,
    private dataService: DataService,
    private bookingService: BookingService,
    private bookingSessionService: BookingSessionService,
    private filterPredicate: FilterpredicateService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private pdfService: PdfService,
    private tooltip: TooltipService,
    private faIconService: FaiconService,
    private dialog: MatDialog

  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getDataToCheckBox(column: string) {
    let data = this.dataSource?.filteredData;

    if (this.valueFilter.length && this.valueFilter[0].column === column) {
      data = this.dataSource.data;
    }
    return data;
  }

  closePopUp(): void {
    this.dataService.resetPopUp();
  }

  changePreview(book: BookingUser): void {
    this.bookOverview = book;
    this.bookingSessionService.getSessionsByBooking(book.bookingKey).subscribe({
      next: sessionBook => this.sesisonBookSelected = sessionBook
    });
  }

  // returnStatus(statusKey: number): BookingStatus {
  //   return this.bookingStatus?.find(status => status.bookedOfferStatusKey === statusKey);
  // }

  // getStatusOffer(): string[] {
  //   return [... new Set(this.bookingByClub.map(o => this.returnStatus(o.bookingStatusKey)?.bookedOfferStatus))];
  // }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = JSON.stringify(this.valueFilter)?.trim().toLowerCase();
  }

  exportPdfBill(book: BookingUser): void {
    this.pdfService.getPdfBookedSession(book.bookingKey).subscribe({
      next: blob => {
        const data = window.URL.createObjectURL(<any>blob.body);
        const anchor = document.createElement('a');
        const date = new Date();
        const time = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2);
        anchor.href = data;
        anchor.download = `NPHDF-${date.getFullYear()}-${book.bookingKey}-${time}.pdf`;
        anchor.click();

        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      }
    });
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }


  // private getBookingStatus(): void {
  //   this.bookingService.getBookingStatus().subscribe({
  //     next: bookingStatus => this.bookingStatus = bookingStatus
  //   });
  // }

  private getBookingClosed(): void {
    this.bookingSessionService.getBookingByClub(this.clubCode).subscribe({
      next: booking => {
        this.bookingByClub = booking;

        setTimeout(() => {
          this.dataSource.data = booking;
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.dataSource.filterPredicate = this.filterPredicate.getFilterPredicate(this.dataSource);
        });



        setTimeout(() => { this.initTable(booking); });

        this.subscription.add(
          this.dataService.valueFilterPopUpSelected$.subscribe({
            next: valueFilter => {
              this.valueFilter = valueFilter;
              if (valueFilter) { this.getOfferByClubWithFilter(valueFilter); }
              this.cdr.detectChanges();
            }
          })
        );
      }
    });

  }

  private getOfferByClubWithFilter(valueFilter: FilterPopUpTable[]): void {
    if (valueFilter.length) {
      this.dataSource.filter = JSON.stringify(valueFilter).trim().toLowerCase();
      if (this.valueFilter.length < 2) {
        this.filterPredicate.dataFilteredTable$.next(this.dataSource.filteredData);
      }
    }
  }

  private initTable(bookedOfferClub: BookingUser[]): void {
    const sortByDate = bookedOfferClub.sort((a, b) => (new Date(b.bookingRecordDate) as any) - (new Date(a.bookingRecordDate) as any));
    // for (const o of sortByDate) {
    //   o.bookingStatusKeyName = this.returnStatus(o.bookingStatusKey)?.bookedOfferStatus;
    // }

    this.bookOverview = sortByDate[0];
    // this.dataSource = new MatTableDataSource<BookingUser>(sortByDate);
    // this.dataSource.sort = this.sort;
    // this.dataSource.paginator = this.paginator;

    // this.length = sortByDate.length;
    // this.dataSource.filterPredicate = this.filterPredicate.getFilterPredicate(this.dataSource);

    if (sortByDate?.length) {
      this.bookingSessionService.getSessionsByBooking(sortByDate[0].bookingKey).subscribe({
        next: sessionBook => this.sesisonBookSelected = sessionBook
      });
    }
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = this.userConnected.club_code || this.route.snapshot.queryParams.clubCode;

    this.getBookingClosed();
    // this.getBookingStatus();
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.valueFilterPopUpSelected$.subscribe({
          next: valueFilter => {
            this.valueFilter = valueFilter;
            this.getOfferByClubWithFilter(valueFilter);
            this.cdr.detectChanges();
          }
        })
      );
  }

  openDialogComment(offer) {
    this.dialog.open(OpenDialogTextComponent, {
      data: { text: offer.memoMessageUser, title: "Commentaire de l'utilisateur" }
    });
  }
}
